import React from 'react';

const Divider = () => (
  <hr className="tw-col-span-6 tw-col-start-2 tw-my-10 md_tw-my-16" />
);

export default Divider;
